module.exports = __webpack_public_path__ + "img/icon-calendar-event.eb6fdfac.svg";